import { useCallback } from "react"
import { graphql, useMutation } from "react-relay"
import { Ch_updatePatientCaveEntryInput } from "@/modules/patients/services/ch/__generated__/useChPatientUpdateCaveMutation.graphql.ts"

const mutation = graphql`
  mutation useChPatientUpdateCaveMutation($input: Ch_updatePatientCaveEntryInput!) {
    ch_updatePatientCaveEntry(input: $input) {
      ch_Patient {
        caveEntry {
          message
          updatedAt
          updatedBy
        }
      }
    }
  }
`

export function useChPatientUpdateCaveMutation() {
  const [commit] = useMutation(mutation)

  return useCallback(
    (input: Ch_updatePatientCaveEntryInput, handleComplete?: () => void) => {
      commit({
        variables: { input },
        onCompleted: handleComplete,
      })
    },
    [commit],
  )
}
